import { FC } from "react";

import {
  BulkMultiselectBoundTemplate,
  BulkMultiselectTemplate,
  BulkTagsTemplate,
  BulkTextareaTemplate,
} from "@ryde/controls";
import { FORM_FIELD_KEYS, ICustomField } from "@ryde/shared";

import { fieldNameToField } from "./field-name-to-field";

export const bulkFieldNameToField: Record<FORM_FIELD_KEYS, FC<ICustomField>> = {
  ...fieldNameToField,
  multiselect: BulkMultiselectTemplate,
  multiselect_bound: BulkMultiselectBoundTemplate,
  tags: BulkTagsTemplate,
  textarea: BulkTextareaTemplate,
};
